import $apiJSON from '../http/apiJSON'

// Personal Panel API Service

/**
 * Получить личную панель текущего пользователя
 */
export async function getMyPanel() {
  return $apiJSON.get('account/personal-panel/my_panel/')
}

/**
 * Добавить элемент в личную панель
 * @param {string} itemType - Тип элемента: 'anime', 'movie', 'chat', 'forum', 'server'
 * @param {string} itemId - ID или slug элемента
 * @param {object} itemData - Дополнительные данные элемента (title, image, etc.)
 */
export async function addItemToPanel(itemType, itemId, itemData) {
  const panel = await getMyPanel()
  const panelId = panel.data.id
  
  return $apiJSON.post(`account/personal-panel/${panelId}/add_item/`, {
    item_type: itemType,
    item_id: itemId,
    item_data: itemData
  })
}

/**
 * Удалить элемент из личной панели
 * @param {number} panelId - ID панели
 * @param {number} itemId - ID элемента панели
 */
export async function removeItemFromPanel(panelId, itemId) {
  return $apiJSON.post(`account/personal-panel/${panelId}/remove_item/`, {
    item_id: itemId
  })
}

/**
 * Изменить порядок элементов в панели
 * @param {number} panelId - ID панели
 * @param {Array} itemsOrder - Массив объектов [{id: 1, order: 0}, {id: 2, order: 1}, ...]
 */
export async function reorderPanelItems(panelId, itemsOrder) {
  return $apiJSON.post(`account/personal-panel/${panelId}/reorder_items/`, {
    items_order: itemsOrder
  })
}

/**
 * Получить все элементы личной панели
 */
export async function getPanelItems() {
  return $apiJSON.get('account/personal-panel-items/')
}

/**
 * Создать элемент личной панели
 * @param {object} itemData - Данные элемента
 */
export async function createPanelItem(itemData) {
  return $apiJSON.post('account/personal-panel-items/', itemData)
}

/**
 * Обновить элемент личной панели
 * @param {number} itemId - ID элемента
 * @param {object} itemData - Обновленные данные
 */
export async function updatePanelItem(itemId, itemData) {
  return $apiJSON.patch(`account/personal-panel-items/${itemId}/`, itemData)
}

/**
 * Удалить элемент личной панели
 * @param {number} itemId - ID элемента
 */
export async function deletePanelItem(itemId) {
  return $apiJSON.delete(`account/personal-panel-items/${itemId}/`)
}

/**
 * Получить заметки пользователя
 */
export async function getPersonalNotes() {
  return $apiJSON.get('account/personal-notes/')
}

/**
 * Создать новую заметку
 */
export async function createPersonalNote(text) {
  return $apiJSON.post('account/personal-notes/', { text, archived: false })
}

/**
 * Обновить заметку
 */
export async function updatePersonalNote(noteId, payload) {
  return $apiJSON.patch(`account/personal-notes/${noteId}/`, payload)
}

/**
 * Удалить заметку
 */
export async function deletePersonalNote(noteId) {
  return $apiJSON.delete(`account/personal-notes/${noteId}/`)
}

export default {
  getMyPanel,
  addItemToPanel,
  removeItemFromPanel,
  reorderPanelItems,
  getPanelItems,
  createPanelItem,
  updatePanelItem,
  deletePanelItem,
  getPersonalNotes,
  createPersonalNote,
  updatePersonalNote,
  deletePersonalNote
}
